import ReferentielsController from './referentiels.controller';

export default {
    template: require('./referentiels.html'),
    controller: ReferentielsController
};
